//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[],[[["fontFamily","fontStyle","fontSize"],"GetDefaultStandardTextFont",{},0,0],[["fontFamily","fontStyle","fontSize"],"SetDefaultStandardTextFont",{},3,0]],[]];
SPLM.Preferences.VisualizationFonts = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.VisualizationFonts";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.VisualizationFonts.StyleType = Object.freeze({
    "Regular" : "Regular", "Bold" : "Bold", "Italic" : "Italic", "BoldItalic" : "BoldItalic"});

export default SPLM;